import { i18n } from "@/setup/i18n-setup";
import { v4 } from "uuid";
import { DashboardItem } from "./dashboard-item";
import { DashboardQuickAddButton } from "./dashboard-quick-add-button";
import { DashboardTabShare } from "./dashboard-tab-share";

export class DashboardTab {
	uid:string = v4();
	ID:number = 0;
	UserID:number = 0;
	Name:string = i18n.t("components.dashboard.new-tab").toString();
	Items:DashboardItem[] = [];
	QuickAddButtons:DashboardQuickAddButton[] = [];
	Shares:DashboardTabShare[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.ID = data.ID || 0;
		this.Name = data.Name;
		this.UserID = data.UserID;
		this.Items = (data.Items as any[] || []).map(d=>new DashboardItem(d));
		this.QuickAddButtons = (data.QuickAddButtons as any[] || []).map(d=>new DashboardQuickAddButton(d));
		this.Shares = (data.Shares as any[] || []).map(s=>new DashboardTabShare(s));
	}

	public getJSON(){
		return {
			ID: this.ID,
			UserID: this.UserID,
			Name: this.Name,
			Items: this.Items.map(c=>c.getJSON()),
			QuickAddButtons: this.QuickAddButtons.map(b=>b.getJSON()),
			Shares: this.Shares.map(s=>s.getJSON())
		};
	}
}